<template>
  <div style="font-size: 11px;cursor: pointer">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="98%">
      <voip-testing-panel :defaultDestination="destinationId" :defaultDivision="vendorDivisionId" :defaultRate="rateId"
                          :editMode="false" :onCreateCallback="callEstablished"
                          v-if="dialogVisible"></voip-testing-panel>
    </el-dialog>
    <div @click="openDialog" v-if="!prefix && isUserMrtEnterprise && rateId && mouseover">
      <i class="el-icon-phone" style="font-size: 21px;padding-top: 4px"></i>
    </div>
    <div v-else-if="!prefix && isUserMrtEnterprise && rateId && !mouseover">
      {{ (vendor) ? String(vendor).slice(0, 15) : '' }}
    </div>
    <div v-else-if="!mouseover">
      <div v-if="!isUserReseller && !isUserCustomer">
        {{ (vendor) ? String(vendor).slice(0, 15) : '' }}
      </div>
      {{ prefix }}
    </div>
    <div @click="openDialog" v-else-if="prefix">
      <i class="el-icon-phone" style="font-size: 21px;padding-top: 4px"></i>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [panelMixin],
  components: {
    voipTestingPanel: () => import('@/modules/voip-testing-panel/broadcast-form/View')
  },
  props: {
    vendor: {
      required: true
    },
    rateId: {
      required: true
    },
    destinationId: {
      required: true
    },
    prefix: {
      required: true
    },
    rateKey: {
      required: true
    },
    destKey: {
      required: true
    },
    callIsOnGoingFunc: {
      required: true
    }
  },
  data() {
    return {
      isChecked: null,
      dialogVisible: false,
      mouseover: false,
      vendorDivisionId: null,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserMrtEnterprise: $store.getters['user-state/isUserMrtEnterprise'],
      dom: null
    }
  },
  mounted() {
    this.isChecked = this.checked
    this.dom = this.$el
    this.dom.parentNode.addEventListener('mouseover', () => {
      this.mouseover = true
    })

    this.dom.parentNode.addEventListener('mouseleave', () => {
      this.mouseover = false
    })
  },
  methods: {
    callEstablished(dataMessage) {
      this.callIsOnGoingFunc(this.destKey, this.rateKey, dataMessage)
    },
    openDialog() {
      this.panelMixin_getVendorDivisionByName({name: this.vendor}, (r) => {
        this.vendorDivisionId = r.data
        this.dialogVisible = true
      })
    }
  }
}
</script>
